import { render, staticRenderFns } from "./MultiTenantEnvironments.vue?vue&type=template&id=15fff0d9&scoped=true&"
import script from "./MultiTenantEnvironments.vue?vue&type=script&lang=ts&"
export * from "./MultiTenantEnvironments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fff0d9",
  null
  
)

export default component.exports